import styled from 'styled-components'

export const StyledLonMarketContainer = styled.div`
  margin-top: 80px;

  .title {
    margin-left: 10px;

    color: #9598ab;
    font-weight: 500;
    font-size: 17px;
    line-height: 27px;
  }

  ${({ theme }) => theme.media.sm`
    margin-top: 48px;
  `}
`

export const StyledStakeDataContainer = styled.div`
  display: flex;
  .data-container {
    position: relative;
    flex: 1;
  }
  .middle-container {
    position: relative;
    margin: 0 30px;
  }
  @media screen and (max-width: 640px) {
    display: flex;
    flex-direction: column;
    .middle-container {
      margin: 15px 0px !important;
    }
    .data-container {
      .content {
        font-size: 21px;
      }
    }
  }
`

export const StyledXLonScaleWrapper = styled.span`
  display: inline-block;
  height: 19px;
  padding: 0 8px;
  border-radius: 20px;
  background: #ceceeb;
  font-size: 11px;
  font-weight: 400;
  line-height: 19px;
  color: #ffffff;
`

export const StyledButton = styled.a`
  position: absolute;
  right: 20px;
  bottom: 24px;
  background: #5f4dbc;
  border-radius: 34px;
  color: #fff;
  padding: 6px 15px;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  outline: none;
  border: none;

  &:hover {
    color: #fff;
  }
`
